import {BUTTONS, tipsToCard} from '../steps-runtime';
import event, {EVENTS} from '../../lib/event';
import React from 'react';
import {BATCH_TIPS_MODE, GUIDE_MODE, OPACITY_FOCUS_COVER, ZINDEX_FOCUS_COVER} from '../../lib/constant';
import {renderCover} from '../../lib/utils';

/**
 * 弹出提示信息
 * @param {string} title - 标题，可选
 * @param {string} msg - 提示文字
 * @param {string} goto - 可选，如果存在，消息展示确认后，自动跳转到某个步骤
 * @returns {promise} 取消按钮 reject、确定按钮 resolve
 */
export default function showMsg ({title, msg, goto}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    return new Promise((resolve, reject) => {
        let lines = [];
        if (title) {
            lines.push({text: title, style:'h1'});
        }
        if (msg) {
            let card = tipsToCard(_index.actionIndex, msg);
            lines = lines.concat(card.lines);
        }
        window.stepsRuntime.insertCard(_index.stepIndex, {actionIndex: _index.actionIndex, lines}, mode === BATCH_TIPS_MODE);
        if (mode === GUIDE_MODE) {
            renderCover();
        }
        if (mode != BATCH_TIPS_MODE) {
            window.stepsRuntime.addContinueButton();
        }
        if (goto) {
            resolve({goto})
        }else {
            resolve();
        }
    });
}
